import { ColumnDef, RowDef } from '@/components/Table/types';
import { twMerge } from 'tailwind-merge';

type FooterTableRow<T> = {
  row: RowDef<T>;
  columns: ColumnDef<T>[];
  className?: string;
};

export const FooterTableRow = <T,>({
  row,
  columns,
  className,
}: FooterTableRow<T>) => {
  return (
    <tr>
      {columns.map((column) => (
        <td
          key={`${column.id}-item-${row.id}`}
          className={twMerge(
            'border-b border-t border-gray-200 p-2.5 text-sm text-gray',
            className,
          )}
          align={column.alignment ?? 'center'}
        >
          {column.renderFooterRow?.(row) ??
            column.renderRow?.(row) ??
            `${row[column.accessor]}`}
        </td>
      ))}
    </tr>
  );
};
